import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_STRIPE_SESSION_STATUS } from "api";

export interface SessionStatus {
  status: string;
  email: string;
  plan_name: string;
  price: number;
  payment_intent_id: string | null;
}

function fetchStripeSessionStatus(session_id: string): Promise<SessionStatus> {
  return fetch(`${GET_STRIPE_SESSION_STATUS(session_id)}`);
}

// React Query hook
export function useGetStripeSessionStatus(
  payment_method: string | undefined,
  session_id: string | undefined
) {
  return useQuery({
    queryKey: ["useGetStripeSessionStatus", session_id],
    queryFn: async () => await fetchStripeSessionStatus(session_id ?? ""),
    enabled: payment_method === "stripe" && session_id !== undefined,
  });
}

export default useGetStripeSessionStatus;
